import React, { Component } from 'react';
import Checkbox from '../Checkbox';
import isEmail from 'validator/lib/isEmail';
class UserForm extends Component {
	render() {
		const {
			show,
			form: { title, inputs, selects, cta },
			clicked,
			changed,
			closed,
			submitted
		} = this.props;

		const formClass = ['Form', show ? 'is-visible' : ''].join(' ');

		let disableButton = true;

		const inputsTpl = inputs.map(field => {
			disableButton =
				disableButton &&
				typeof field.value === 'string' &&
				field.value.trim() !== '';

			return (
				<input
					key={field.name}
					name={field.name}
					onChange={changed}
					type={field.type}
					className="Form-input"
					placeholder={field.placeholder}
					autoComplete="off"
					value={field.value}
				/>
			);
		});

		const selectsTpl = selects.map(field => {
			disableButton =
				disableButton &&
				(field.hasOwnProperty('values') && field.values.length);

			if (field.type === 'radio') {
				const options = field.items.map((item, index) => {
					return (
						<Checkbox
							clicked={clicked}
							checked={field.values.indexOf(item.value) > -1}
							key={index}
							value={item.value}
							index={index}
							name={field.name}
						>
							{item.label}
						</Checkbox>
					);
				});

				return (
					<div
						className="Form-column Form-column--vertical"
						style={{
							width: '25%',
							margin: '0 0 0 auto',
							transform: 'translateY(-52px)'
						}}
						key={field.name}
					>
						{field.hasOwnProperty('label') && (
							<label className="Form-label">{field.label}</label>
						)}
						{options}
					</div>
				);
			}
		});

		return (
			<div className={formClass}>
				<button className="Form-close" onClick={closed}>
					Close
				</button>
				<h2 className="Form-title">{title}</h2>
				<div className="Form-content">
					<div className="Form-column" style={{ width: '65%' }}>
						{inputsTpl}
					</div>
					{selectsTpl}
				</div>
				<button
					disabled={!disableButton}
					className="Form-button"
					onClick={submitted}
				>
					{cta}
				</button>
			</div>
		);
	}
}

export default UserForm;
